package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetNamesByIdPayload(
    val organization: String,
    @SerialName("sessionID")
    val sessionId: String,
    @SerialName("userID")
    val userId: String,
    @SerialName("seasonID")
    val seasonId: String,
)


@Serializable
data class GetNamesByIdResponse(
    val data: List<GetNamesByIdData>,
)

@Serializable
data class GetNamesByIdData(
    val keyWordType: String,
    val nameCategory: String,
    val text: String,
    val usageCount: Long,
)
